import React from "react";
import styled, { withTheme } from "styled-components";
import { FormattedMessage } from "react-intl";
import { withRouter } from "react-router";
import { LanguageSelectorMenu } from "./LanguageSelector";
import { getImagePath } from "@educhain/utils/theme/getImagePath";
const StyledFooter = styled.footer`
    @media (max-width: 992px) {
        display: flex;
        flex-flow: column-reverse;
    }

    font-weight: 300;
    color: rgba(0, 0, 0, 0.65);
    font-size: 12px;
    border-top: 2px solid #f5f5f5;
    z-index: 1;

    ul {
        @media (max-width: 992px) {
            margin: 5px 0;
            text-align: center;
         }

        padding: 0;
        font-weight: 300;
        position: relative;

        li {
            list-style: none;
            display: inline-block;
          }

        }

   a {
        color: rgba(0, 0, 0, 0.65);
        display: inline-block;
        vertical-align: middle;
        line-height: 20px;
        transition: all 0.3s ease-in-out;
        text-decoration: none;

        &:hover {
            color: rgba(0, 0, 0, 0.4);
        }
    }
    span {
        color: rgba(0, 0, 0, 0.65);
        display: inline-block;
        vertical-align: middle;
        line-height: 20px;
        transition: all 0.3s ease-in-out;
        text-decoration: none;
    }

   li:not(:last-child)::after {
     ${({
  theme: {
    rtl
  }
}) => rtl ? "content: ''" : "content: '|'; margin: 0 10px;"};
        }

   li:not(:first-child)::before {
     ${({
  theme: {
    rtl
  }
}) => rtl ? "content: '|'; margin: 0 10px" : "content: '';"};
        }
    .footer-contents {
    @media (max-width: 992px) {
        flex-direction: column-reverse;
        align-items: center
        }

        display: flex;
        justify-content: space-between;
        margin: auto;
    }

    .footer-bottom {
          @media (max-width: 992px) {
            margin-top: -10px;
            justify-content: center;
            flex-direction: column-reverse;
            align-items: center;
          }

        display: flex;
        justify-content: space-between;

        .power-wrapper {
            padding-top: 3px;
         }

        .link-wrapper {
            margin-top: 3px
         }
    }

    .footer-img {
        height: 24px;
        margin-bottom: 3px;
    }
}
`;

const BaseFooter = ({
  theme: {
    footerLinks = []
  },
  className = "",
  redirectName,
  redirectPath,
  isRTLEnabled = false,
  theme
}) => {
  return React.createElement(StyledFooter, {
    className: className
  }, React.createElement("div", {
    className: "footer-contents"
  }, React.createElement("div", null, React.createElement("span", null, !!theme.footerCC ? React.createElement(FormattedMessage, {
    id: theme.footerCC
  }) : React.createElement(FormattedMessage, {
    id: "footer.copyTM"
  }))), React.createElement("div", null, React.createElement("ul", null, isRTLEnabled && React.createElement("li", {
    key: "languageSelect"
  }, React.createElement(LanguageSelectorMenu, null)), React.createElement("li", {
    key: "verifyCredential"
  }, React.createElement("a", {
    href: redirectPath
  }, redirectName))))), React.createElement("div", {
    className: "footer-bottom"
  }, React.createElement("div", {
    className: "link-wrapper"
  }, React.createElement("ul", null, footerLinks.map(({
    text,
    href
  }, i) => {
    return React.createElement("li", {
      key: i
    }, React.createElement("a", {
      target: "_blank",
      href: href
    }, React.createElement(FormattedMessage, {
      id: text
    })));
  }))), React.createElement("div", {
    className: "power-wrapper"
  }, React.createElement(FormattedMessage, {
    id: "shared.power"
  }), " ", React.createElement("img", {
    className: "footer-img",
    src: getImagePath(theme.assets.educhain),
    alt: ""
  }))));
};

export const Footer = withRouter(withTheme(BaseFooter));